import type { SearchPosting } from "@/lib/api/catalogue";
import type { Application } from "@/lib/api/envoy";
import type { PostingFit } from "@/lib/api/resumeService";
import { SaveButton } from "@/components/site/PostingActions";
import { fitIn, jobCard } from "@/lib/jobs";
import JobCard from "./JobCard";

/** The result cards, the open one marked, each with Save once the sign in is known. */
export default function JobsCardList({
    postings,
    applications,
    fits,
    now,
    openId,
    member,
    showSave,
    linkCompanies = true,
    onOpen,
}: {
    postings: SearchPosting[];
    applications: Readonly<Record<string, Application>> | undefined;
    fits: Readonly<Record<string, PostingFit>> | null | undefined;
    now: Date;
    openId: string | undefined;
    member: boolean;
    showSave: boolean;
    linkCompanies?: boolean;
    onOpen: (postingId: string) => void;
}) {
    return postings.map((posting) => (
        <JobCard
            key={posting.posting_id}
            linkCompany={linkCompanies}
            card={jobCard(
                posting,
                applications?.[posting.posting_id],
                fitIn(fits, posting.posting_id),
                now,
            )}
            selected={openId === posting.posting_id}
            onOpen={() => onOpen(posting.posting_id)}
            member={member}
            actions={
                showSave ? (
                    <SaveButton postingId={posting.posting_id} title={posting.title} size="sm" />
                ) : null
            }
        />
    ));
}
